import { FC } from 'react'

export const Telegram: FC = () => (
  <svg
    width="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.86327 16.2763C8.53977 15.3571 10.4104 14.5885 12.1584 13.8167C15.1663 12.5521 18.1853 11.3112 21.236 10.1544C21.8293 9.95785 22.895 9.76451 23 10.6409C22.9427 11.8818 22.7073 13.1147 22.545 14.3476C22.1347 17.0591 21.6607 19.7611 21.1994 22.4632C21.0403 23.3633 19.9078 23.8293 19.1841 23.254C17.444 22.0829 15.6895 20.9228 13.9716 19.7247C13.4086 19.1542 13.9303 18.3365 14.433 17.9292C15.8661 16.5219 17.3867 15.3254 18.7451 13.8452C19.111 12.9642 18.0293 13.7058 17.6715 13.9341C15.7087 15.2811 13.7952 16.7105 11.7257 17.8959C10.6696 18.4759 9.43688 17.9799 8.38071 17.6566C7.4343 17.2652 6.0457 16.8721 6.86168 16.2763H6.86327Z"
      fill="currentColor"
    />
  </svg>
)
